<h2>All Holdbacks</h2>

<div style="display:flex; gap:12px; align-items:center; margin-bottom: 12px;">
  <nz-select [(ngModel)]="status" nzAllowClear nzPlaceHolder="Status" style="width: 160px;">
    <nz-option nzValue="pending" nzLabel="Pending"></nz-option>
    <nz-option nzValue="released" nzLabel="Released"></nz-option>
    <nz-option nzValue="forfeited" nzLabel="Forfeited"></nz-option>
  </nz-select>
  <input nz-input [(ngModel)]="userId" placeholder="User ID" style="width: 240px;" />
  <nz-date-picker [(ngModel)]="from" nzPlaceHolder="From"></nz-date-picker>
  <nz-date-picker [(ngModel)]="to" nzPlaceHolder="To"></nz-date-picker>
  <button nz-button nzType="primary" (click)="load()">Filter</button>
  <button nz-button (click)="status=''; userId=''; from=null; to=null; load();">Clear</button>
  <span *ngIf="loading">Loading...</span>
  <span *ngIf="!loading">Found {{ data.length }} records</span>
  
</div>

<nz-table [nzData]="data" [nzShowPagination]="true">
  <thead>
    <tr>
      <th>User</th>
      <th>Customer</th>
      <th>Amount</th>
      <th>Status</th>
      <th>Planned Release</th>
      <th>Created</th>
      <th>Work Order</th>
      <th>Notes</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let h of data">
      <td>{{ h.user?.first_name }} {{ h.user?.last_name }}</td>
      <td>{{ h.customer?.first_name }} {{ h.customer?.last_name }}</td>
      <td>{{ h.holdback_amount | currency }}</td>
      <td>
        <nz-tag [nzColor]="h.status === 'pending' ? 'gold' : (h.status === 'released' ? 'green' : 'red')">{{ h.status }}</nz-tag>
      </td>
      <td>{{ h.planned_release_date | date }}</td>
      <td>{{ h.created_at | date }}</td>
      <td>{{ h.work_order_id }}</td>
      <td>{{ h.notes }}</td>
    </tr>
  </tbody>
</nz-table>


